import options from "./options";

// export const API = `https://${options.back.path}:${options.back.port}`;
export const API = `https://${options.back.path}/api`;